import { useEffect, useState } from 'react'

import { useCourts } from './useCourts'

import { CourtModel } from '../../types/court/court'

/** Active courts (with their club) for eligibility pickers in admin forms. */
export const useCourtOptions = () => {
  const courtsHook = useCourts()
  const [courts, setCourts] = useState<CourtModel[]>([])
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    let active = true
    courtsHook.courts(200).then(page => {
      if (active) {
        setCourts(page?.content ?? [])
        setLoaded(true)
      }
    })
    return () => {
      active = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { courts, loaded, error: courtsHook.error }
}
